import {useState,useEffect,useRef} from 'react'
import Form from 'react-bootstrap/Form'
import styles from './TimePicker.module.css'
import {addZero} from '../../util/datetime'

const DropInput = ({placeholder,options,value,onSelect,showOptions,setOpenOptions,optionType})=>{
	const cleanValue = v => isNaN(v) || v==="" ? "" : addZero(v)
	//Doing a local/global state value pattern to allow
	//type a 0 without it triggering the logic and converting
	//it to a 12. Local value gets updated on input
	//global value gets update on blur. This allows external
	//global state to also control the inputs
	const [localValue,setLocalValue] = useState(cleanValue(value))
	useEffect(()=>{
		setLocalValue(cleanValue(value))
	},[value])

	const close = ()=>{setOpenOptions("none")}
	useEffect(()=>{
		window.addEventListener("click",close)
		return ()=>{
			window.removeEventListener("click",close)
		}
	},[])

	return (
		<div className={styles.DropInput}>
			<Form.Control
				type="number"
				style={{fontSize:'14px',minWidth:'60px'}}
				onClick={e=>{
					e.stopPropagation()
				}}
				value={localValue}
				className="text-center px-2"
				onFocus={(e)=>{
					e.target.select()
					setOpenOptions(optionType)
				}}
				onChange={e=>{
					setLocalValue(e.target.value)
				}}
				onBlur={(e)=>{
					const newValue = e.target.value
					if(parseInt(newValue)===parseInt(value)) return
					setOpenOptions("none")
					onSelect(parseInt(e.target.value))
				}}
				placeholder={placeholder}
				
			/>
			<div className={[styles.DropOptions,showOptions?styles.Show:''].join(' ')}>
				{options.map(o=>(
					<div
						key={o}
						onMouseOver={()=>{
							setLocalValue(o)
						}} 
						onMouseLeave={()=>{
							setLocalValue(value)
						}}
						onClick={()=>{
							onSelect(o)
						}}>
						{o}
					</div>
				))}
			</div>
		</div>
	)
}

const getHourOptions = (isTime24Hour)=>{
	let startHourRange = isTime24Hour ? 0 : 1
	let endHourRange =  isTime24Hour ? 23 : 12

	const options = []
	for(let i = startHourRange; i <= endHourRange; i++){
		options.push(i)
	}
	return options
}

const getMinuteOptions = minuteInterval => {
	const options = []
	for(let i = 0; i <= 60 - minuteInterval; i+=minuteInterval){
		options.push(i)
	}
	return options
}

const TimePicker = ({onChange,hour,minute,period,minuteInterval=15, isTime24Hour=false})=>{
	//only let one drop option list be open at a time by
	//specifying which one is currently open
	const [openOptions,setOpenOptions] = useState('none')
	hour = parseInt(hour)
	hour = isNaN(hour) ? '' : hour
	minute = parseInt(minute)
	minute = isNaN(minute) ? '' : minute

	return (
		<div className="d-flex align-items-center">
			<DropInput 
				showOptions={openOptions==='hour'}
				setOpenOptions={setOpenOptions}
				value={
					isTime24Hour
					? hour
					: (
						hour > 12
						? hour - 12
						: (hour === 0 ? 12 : hour)
					)
				}
				optionType="hour"
				onSelect={(hour)=>{

					hour = (
						(!isTime24Hour)
						? (
							period==='p'
							? (hour < 12 ? hour + 12 : hour)
							: (hour === 12 ? 0 : hour)
						)
						: hour
					)
					onChange({
						hour,
						min:minute,
						p:period
					})
				}}
				placeholder="HH" 
				options={getHourOptions(isTime24Hour)}
			/>
			<span className="mx-1">:</span>
			<DropInput 
				//comment
				showOptions={openOptions==='minute'}
				setOpenOptions={setOpenOptions}
				value={minute}
				optionType="minute"
				onSelect={(min)=>{
					onChange({
						hour,
						min,
						p:period,
					})
				}}
				placeholder="MM" 
				options={getMinuteOptions(minuteInterval)}
			/>
			<span className="ml-1"/>
			{!isTime24Hour && <Form.Control 
				onChange={e=>{
					const p = e.target.value
					hour = (
						!isTime24Hour
						? (p==='p'?hour%12 + 12:hour-12)
						: hour
					)
					onChange({
						hour,
						min:minute,
						p
					})
				}}
				value={period}
				size="sm" 
				as="select" 
				style={{width:'64px',fontSize:'16px'}}
			>
				<option value="a">AM</option>
				<option value="p">PM</option>
			</Form.Control>}
		</div>
	)
}

export default TimePicker